export default __webpack_public_path__ + "static/media/pdf.99b03b28.svg";